export const locale = {
    lang: 'es',
    data: {
        TIPOSSERVICIO: {
            LIST: {
                TITLE: 'TIPOS DE SERVICIO'
            }
        }
    }
};
